import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import actions from '../actions';
import { GlobalMsg, Loader, ModalContainer } from '../components';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

//Styles
import './../../scss/main.scss';
import './../../scss/components/_shell.scss';

const OKTA_URL = 'https://zillow.okta.com';

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			stickyGlobalMessage: false,
			currentMenuLocation: {},
		};

		this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {
		this.deduceMenuFromLocation(this.props);

		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillReceiveProps(nextProps) {
		// Check if the existing session user was loaded
		if (this.props.data.loading === true && nextProps.data.loading === false) {
			if (nextProps.data.viewer) {
				this.props.authActions.receiveSessionUser(nextProps.data.viewer);
			} else {
				window.location = OKTA_URL;
			}
		}

		// Redirect to 403 if the user does not have view-feed-dashboard permission
		if (
			this.props.user !== nextProps.user ||
			this.props.location.pathname !== nextProps.location.pathname
		) {
			if (
				nextProps.user.isLoggedIn() &&
				!nextProps.user.can('view-feed-dashboard') &&
				nextProps.location.pathname !== '/forbidden'
			) {
				browserHistory.push('/forbidden');
			}
		}

		this.deduceMenuFromLocation(nextProps);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	deduceMenuFromLocation(props) {
		var pathString = _.join(_.map(props.routes, 'path'), '');
		if (_.startsWith(pathString, '/corporations')) {
			this.setState({ currentMenuLocation: { corporations: 'current-menu' } });
		}
		if (_.startsWith(pathString, '/feeds')) {
			this.setState({ currentMenuLocation: { feeds: 'current-menu' } });
		}
		if (_.startsWith(pathString, '/customers')) {
			this.setState({ currentMenuLocation: { customers: 'current-menu' } });
		}
		if (_.startsWith(pathString, '/reports')) {
			this.setState({ currentMenuLocation: { reports: 'current-menu' } });
		}
	}

	handleClickSignOut = async e => {
		e.preventDefault();
		await this.props.deleteSession();
		window.location = OKTA_URL;
	};

	handleClickGlobalAlert() {
		this.props.globalMsgActions.clearGlobalMsg();
	}

	handleScroll() {
		if (this.props.globalMsg.message) {
			const globalMsgPosition = ReactDOM.findDOMNode(
				this.refs.globalMsg,
			).getBoundingClientRect();

			if (globalMsgPosition.top >= 0) {
				this.setState({ stickyGlobalMessage: false });
			} else {
				this.setState({ stickyGlobalMessage: true });
			}
		}
	}

	render() {
		const { user, globalModal } = this.props;

		if (this.props.data.loading) {
			return <Loader wholePage />;
		}

		return (
			<div className="frost-container">
				<div className="header">
					<div className="row row-align-center">
						<h2 className="site-title">
							<Link to="/">
								<img src="/assets/img/logo-FD.svg" alt="Zillow Feed Dashboard" />
							</Link>
						</h2>
						<If condition={user.can('view-feed-dashboard')}>
							<If condition={user.can('full-data-browsing')}>
								<div>
									<Link
										className={this.state.currentMenuLocation.corporations}
										to="/corporations">
										<div
											className={
												'header-icon icon globe ' +
												this.state.currentMenuLocation.corporations
											}></div>{' '}
										Corporations
									</Link>
								</div>
							</If>
							<If condition={user.can('view-feed-list')}>
								<div>
									<Link
										className={this.state.currentMenuLocation.feeds}
										to="/feeds">
										<div
											className={
												'header-icon icon feeds ' +
												this.state.currentMenuLocation.feeds
											}></div>{' '}
										Feeds
									</Link>
								</div>
							</If>
							<If condition={user.can('view-customer-list')}>
								<div>
									<Link
										className={this.state.currentMenuLocation.customers}
										to="/customers">
										<div
											className={
												'header-icon icon briefcase ' +
												this.state.currentMenuLocation.customers
											}></div>{' '}
										Customers
									</Link>
								</div>
							</If>
							<If condition={this.props.user.can('view-report')}>
								<div>
									<Link
										className={this.state.currentMenuLocation.reports}
										to="/reports">
										<div
											className={
												'header-icon icon report ' +
												this.state.currentMenuLocation.reports
											}></div>{' '}
										Reports
									</Link>
								</div>
							</If>
						</If>
						<If condition={this.props.user.isLoggedIn()}>
							<div className="cell justify-right">
								<a
									className="justify-right"
									href="#"
									onClick={e => this.handleClickSignOut(e)}>
									<div className="header-icon icon logout"></div>
								</a>
							</div>
						</If>
					</div>
				</div>

				<If condition={this.props.globalMsg.message}>
					<GlobalMsg
						ref="globalMsg"
						className={this.state.stickyGlobalMessage ? 'sticky' : ''}
						msg={this.props.globalMsg}
						onClick={() => this.handleClickGlobalAlert()}
					/>
				</If>

				{this.props.children}

				<ModalContainer open={globalModal.isGlobalModalContainerOpen}></ModalContainer>
			</div>
		);
	}
}

App.propTypes = {
	globalModal: PropTypes.object,
	globalMsg: PropTypes.object,
	children: PropTypes.node,
	user: PropTypes.object,
	data: PropTypes.object,
	authActions: PropTypes.object,
	location: PropTypes.object,
	globalMsgActions: PropTypes.object,
	deleteSession: PropTypes.func,
};

const viewerQuery = gql`
	query getCurrentUser {
		viewer {
			id
			rawId: id(raw: true)
			fullName
			firstName
			lastName
			email
			role {
				id
				permissions {
					names
				}
			}
		}
	}
`;

const deleteSessionMutation = gql`
	mutation DeleteSessionMutation {
		deleteSession
	}
`;

export default compose(
	connect(
		state => ({
			globalMsg: state.globalMsg,
			globalModal: state.globalModal,
			user: state.auth.user,
		}),
		dispatch => ({
			authActions: bindActionCreators(actions.auth, dispatch),
			globalMsgActions: bindActionCreators(actions.globalMsg, dispatch),
			globalModalActions: bindActionCreators(actions.globalModal, dispatch),
		}),
	),
	graphql(viewerQuery),
	graphql(deleteSessionMutation, {
		props: ({ mutate }) => ({
			deleteSession: () => mutate(),
		}),
	}),
)(App);



// WEBPACK FOOTER //
// ./src/assets/js/containers/App.js